export enum AvgLevel {
  ORG,
  TEAM,
}
